export default __webpack_public_path__ + "049841c8d6a66cb8dc4c98c392f598d6.svg";